import { useMemo } from 'react'

import { useLocation } from 'react-router-dom'

export const useRouteCheck = (routes: string | string[]) => {
  const location = useLocation()

  const routeArray = useMemo(
    () => (Array.isArray(routes) ? routes : [routes]),
    [routes]
  )

  return useMemo(
    () => routeArray.some(route => location.pathname.startsWith(route)),
    [routeArray, location.pathname]
  )
}
